import React from "react";
import { Container, Skeleton, Stack } from "@mui/material";

const PageSkeleton = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Stack spacing={2}>
        <Skeleton variant="text" width="40%" height={50} />
        <Skeleton variant="rectangular" height={200} />
        <Skeleton variant="rectangular" height={200} />
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="80%" />
      </Stack>
    </Container>
  );
};

export default PageSkeleton;
